import http from '../lib/http'


export interface LanguagePack {
    [key: string]: string;
}

let currentPack: LanguagePack = {};

// 声明全局函数 t
declare global {
    function t(key: string): string;
}

// 初始化语言包
export async function fetchLanguage(lang: 'zh' | 'en' = 'zh') {

    try {
        interface LangResponse {
            en: Record<string, string>;
            zh: Record<string, string>;
        }
        const res = await http.get<LangResponse>(`/api/get_lang_json`);

        const langData = res as any;
        currentPack = langData['en'] || {};
        // 挂载全局 t 函数
        globalThis.t = (key: string) => currentPack[key] || key;

        console.log('语言包加载完成', currentPack);
    } catch (err) {
        console.error('获取语言包失败', err);
        currentPack = {};
        globalThis.t = (key: string) => key;
    }

}
